import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { tap } from 'rxjs/operators';
import { Observable } from 'rxjs';
import { debug } from 'util';

@Injectable({
  providedIn: 'root'
})
export class BudgetserviceService {

  apiUrl: string;

  constructor(private _http: HttpClient) {
    this.apiUrl = 'https://mktgcost.iffco.coop/api/Budget/';
  }


  getSaleBudget(Year: string, StCd: string, CostCenterFo: string) {
    var params = new HttpParams().set('Year', Year).set('StCd', StCd).set('CostCenterFo', CostCenterFo);
    return this._http.get(this.apiUrl + 'SaleBudget', { params: params }).
      pipe(
        tap(data => {
          if (data) { return data }
          else { return null }
        })
      );
  }

  getSaleExpense1(Year: string, StCd: string, CostCenterFo: string) {
    var params = new HttpParams().set('Year', Year).set('StCd', StCd).set('CostCenterFo', CostCenterFo);

    return this._http.get(this.apiUrl + 'SaleExpense1', { params: params }).
      pipe(
        tap(data => {
          if (data) { return data }
          else { return null }
        })
      );
  }

  getSaleExpense2(Year: string, StCd: string, CostCenterFo: string) {
    var params = new HttpParams().set('Year', Year).set('StCd', StCd).set('CostCenterFo', CostCenterFo);

    return this._http.get(this.apiUrl + 'SaleExpense2', { params: params }).
      pipe(
        tap(data => {
          if (data) { return data }
          else { return null }
        })
      );
  }

  getSaleExpense3(Year: string, StCd: string, CostCenterFo: string) {
    var params = new HttpParams().set('Year', Year).set('StCd', StCd).set('CostCenterFo', CostCenterFo);

    return this._http.get(this.apiUrl + 'SaleExpense3', { params: params }).
      pipe(
        tap(data => {
          if (data) { return data }
          else { return null }
        })
      );
  }

  getSaleExpense4(Year: string, StCd: string, CostCenterFo: string) {
    var params = new HttpParams().set('Year', Year).set('StCd', StCd).set('CostCenterFo', CostCenterFo);

    return this._http.get(this.apiUrl + 'SaleExpense4', { params: params }).
      pipe(
        tap(data => {
          if (data) { return data }
          else { return null }
        })
      );
  }
  getSaleExpense21( Year: string, StCd: string, CostCenterFo: string )
  {
    var params = new HttpParams().set('Year', Year).set('StCd', StCd).set('CostCenterFo', CostCenterFo);

    return this._http.get(this.apiUrl + 'SaleExpense2', { params: params }).
      pipe(
        tap(data => {
          if (data) { return data }
          else { return null }
        })
      );
  }
  getSaleExpense41( Year: string, StCd: string, CostCenterFo: string )
  {
    var params = new HttpParams().set('Year', Year).set('StCd', StCd).set('CostCenterFo', CostCenterFo);

    return this._http.get(this.apiUrl + 'SaleExpense4', { params: params }).
      pipe(
        tap(data => {
          if (data) { return data }
          else { return null }
        })
      );
  }

  UploadData(Year: string, CostCenterFo: string) {

    var params = new HttpParams().set('Year', Year).set('CostCenterCode', CostCenterFo).set('IffcoUnitcodeS', localStorage.getItem('IffcoUnitCodeS'));
    return this._http.get(this.apiUrl + 'Upload', { params: params }).
      pipe(
        tap(data => {
          if (data) { return data }
          else { return null }
        })
      );
  }
  AddCostCenter(Year: string, newCostCenterFo: string, newOfcName : string ) {

    var params = new HttpParams().set('Year', Year).set('CostCenterCode', newCostCenterFo).set('newOfcName', newOfcName).set('IffcoUnitcodeS', localStorage.getItem('IffcoUnitCodeS'));
    return this._http.get(this.apiUrl + 'AddCostCenter', { params: params }).
      pipe(
        tap(data => {
          if (data) { return data }
          else { return null }
        })
      );
  }
  ReloadSalesData(Year: string, CostCenterFo: string) {

    var params = new HttpParams().set('Year', Year).set('CostCenterCode', CostCenterFo).set('IffcoUnitcodeS', localStorage.getItem('IffcoUnitCodeS'));
    return this._http.get(this.apiUrl + 'Reload', { params: params }).
      pipe(
        tap(data => {
          if (data) { return data }
          else { return null }
        })
      );
  }
  SaveData(tableData: any) {
    debugger;
    let header = new HttpHeaders({ 'Content-Type': 'application/json' });

    return this._http.post<any>(this.apiUrl + 'SaveData', tableData, { headers: header }).
      pipe(
        tap(data => {
          if (data) { return data }
          else { return null }
        })
      );
  }

  //DeleteBudget(Year: string, StCd: string, CostCenterFo: string) {
  //  var params = new HttpParams().set('Year', Year).set('StCd', StCd).set('CostCenterFo', CostCenterFo);

  //  return this._http.delete(this.apiUrl + 'Delete', { params: params }).
  //    pipe(
  //      tap(data => {
  //        if (data) { return data }
  //        else { return null }
  //      })
  //    );
  //}

}
